module.exports = __webpack_public_path__ + "img/berlinerkranse_sukker_closeup.e507a69f.jpg";